  export const getMobileNumberLengthFromRegex = (regex, countryCode) => {
    if (!regex || !countryCode) return null;

    // Remove escape slashes and anchors
    // eslint-disable-next-line no-useless-escape
    regex = regex.replace(/\\d/g, "d").replace(/[\^\$]/g, "");

    // Remove the country code prefix
    regex = regex.replace(new RegExp("^" + countryCode), "");

    // Look for pattern like d{10}
    const match = regex.match(/d\{(\d+)\}/);
    if (match && match[1]) {
      return parseInt(match[1], 10);
    }

    return 11;
  };

